import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class LegalAgreementEndpoint extends BaseEndpoint {}
